import React, { useState } from "react";
import MUIDataTable from "mui-datatables";

const data = [
  ["John Doe", "johndoe@mail.com", "Male", "New York"],
  ["Jane Smith", "janesmith@mail.com", "Female", "London"],
  ["Bob Johnson", "bjohnson@mail.com", "Male", "Paris"],
];
const handleContextMenu = (event) => {
  event.preventDefault();
};

const columns = [
  {
    name: "Name",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "Email",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "Gender",
    options: {
      filter: true,
      sort: true,
    },
  },
  {
    name: "City",
    options: {
      filter: true,
      sort: true,
    },
  },
];

const Right = () => {
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);

  const handleRowClick = (rowData, rowMeta) => {
    setSelectedRowIndex(rowMeta.rowIndex);
    console.log("left-clicked row data: ", rowData);
  };

  const handleContextMenu = (event, rowData) => {
    event.preventDefault();
    console.log("Right-clicked row data: ", rowData);
  };

  const options = {
    onRowClick: handleRowClick,
    onContextMenu: handleContextMenu,
    selectableRowsOnClick: false,
    selectableRows: "single",
    rowsSelected: [selectedRowIndex],
  };

  return (
    <div onContextMenu={handleContextMenu}>
      <MUIDataTable
        title={"Employee List"}
        data={data}
        columns={columns}
        options={options}
      />
    </div>
  );
};

export default Right;
